var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C7.031 5.5 2 7.046 2 10C2 12.954 7.031 14.5 12 14.5C16.969 14.5 22 12.954 22 10C22 7.046 16.97 5.5 12 5.5ZM7 15.438V18.438C8.237 18.737 9.605 18.92 11 18.979V15.979C9.65239 15.9275 8.31287 15.7464 7 15.438ZM13 15.978V18.978C14.3476 18.9265 15.6871 18.7454 17 18.437V15.437C15.6871 15.7454 14.3476 15.9265 13 15.978ZM19 14.797V17.797C20.801 17.042 22 15.94 22 14.5V11.5C22 12.94 20.801 14.042 19 14.797ZM5 17.797V14.797C3.2 14.042 2 12.939 2 11.5V14.5C2 15.939 3.2 17.042 5 17.797Z",
    fill: "#454951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBet);
export default __webpack_public_path__ + "static/media/bet.162b07f81e174d7f3e3f25fe92ffd275.svg";
export { ForwardRef as ReactComponent };